<div class="main">
    <div class="dx-field-title" translate>environments.pageTitle</div>
    <div class="dx-fieldset" style="height:calc(100vh - 150px)">
        <dx-data-grid #environments
                      [dataSource]="dataSource"
                      keyExpr="id"
                      [columnAutoWidth]="true"
                      [wordWrapEnabled]="true"
                      [focusedRowEnabled]="true"
                      height="100%"
                      hoverStateEnabled="true"
                      [errorRowEnabled]="false"
                      (onContextMenuPreparing)="onContextMenuPreparing($event)"
                      (onRowDblClick)="onRowDblClick($event)"
                      (onRowPrepared)="onRowPrepared($event)">
            <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-summary>
                <dxi-total-item column="name" [displayFormat]="'environments.lblEnvironmentsCount' | translate" summaryType="count"></dxi-total-item>
            </dxo-summary>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div *dxTemplate>
                        <span style="vertical-align:middle;" translate>environments.lblShowDisabledEnvironments</span>
                        <dx-switch style="margin-left:5px;" [value]="showDisabledEnvironments" (valueChange)="filterChanged($event)"></dx-switch>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="displayNewPopup()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadDataSource()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>

            <dxi-column dataField="name" [caption]="'environments.lblName' | translate"></dxi-column>
            <dxi-column dataField="globalTimer" [caption]="'environments.lblGlobalTimer' | translate"></dxi-column>
            <dxi-column dataField="maxDelayToReceiveACK" [caption]="'environments.lblMaxDelayReceiveAck' | translate"></dxi-column>
        </dx-data-grid>
    </div>
</div>

<!-- Display popup -->
<dx-popup [title]="'environments.popupTitle' | translate" [(visible)]="isDisplayPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view *ngIf="isDisplayPopupVisible">
            <div class="dx-field">
                <div class="dx-field-label" translate>environments.lblName</div>
                <div class="dx-field-value">
                    <dx-text-box [value]="selectedEnvironment.name" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>environments.lblGlobalTimer</div>
                <div class="dx-field-value">
                    <dx-text-box [value]="selectedEnvironment.globalTimer" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>environments.lblMaxDelayReceiveAck</div>
                <div class="dx-field-value">
                    <dx-text-box [value]="selectedEnvironment.maxDelayToReceiveACK" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>environments.lblLamIntervalCheckCommandQueue</div>
                <div class="dx-field-value">
                    <dx-text-box [value]="selectedEnvironment.lamIntervalCheckCommandQueue" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>environments.lblLaIntervalCheckCommandQueue</div>
                <div class="dx-field-value">
                    <dx-text-box [value]="selectedEnvironment.laIntervalCheckCommandQueue" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>environments.lblLaDelayBeforeStopping</div>
                <div class="dx-field-value">
                    <dx-text-box [value]="selectedEnvironment.laDelayBeforeStopping" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>environments.lblCountAttemptsBeforeNotification</div>
                <div class="dx-field-value">
                    <dx-text-box [value]="selectedEnvironment.countAttemptsBeforeNotification" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div class="flex bottom-buttons">
                <dx-button class="close" [text]="'_commons.close' | translate" (onClick)="this.isDisplayPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- New & Edit & Copy popup -->
<dx-popup [title]="'environments.popupTitle' | translate" [width]="1200" [height]="640" [(visible)]="isEditPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view *ngIf="isEditPopupVisible">
            <dx-validation-group #environmentValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>
                        environments.lblName<span class="dx-field-item-required-mark">
                            *
                        </span>
                    </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedEnvironment.name">
                            <dx-validator>
                                <dxi-validation-rule type="required" [message]="'environments.msgNameRequired' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="stringLength" [max]="100" message="'_validators.maxLength100' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>environments.lblGlobalTimer</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedEnvironment.globalTimer">
                            <dx-validator>
                                <dxi-validation-rule type="numeric" [message]="'_validators.numeric' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="60" [max]="86400" [message]="'_validators.rangeGlobalTimer' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>environments.lblMaxDelayReceiveAck</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedEnvironment.maxDelayToReceiveACK">
                            <dx-validator>
                                <dxi-validation-rule type="numeric" [message]="'_validators.numeric' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="10" [max]="1440" [message]="'_validators.rangeMaxDelayReceiveAck' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>environments.lblLamIntervalCheckCommandQueue</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedEnvironment.lamIntervalCheckCommandQueue">
                            <dx-validator>
                                <dxi-validation-rule type="numeric" [message]="'_validators.numeric' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="1" [max]="86400" [message]="'_validators.rangelamIntervalCheckCommandQueue' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>environments.lblLaIntervalCheckCommandQueue</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedEnvironment.laIntervalCheckCommandQueue">
                            <dx-validator>
                                <dxi-validation-rule type="numeric" [message]="'_validators.numeric' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="1" [max]="86400" [message]="'_validators.rangeLaIntervalCheckCommandQueue' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>environments.lblLaDelayBeforeStopping</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedEnvironment.laDelayBeforeStopping">
                            <dx-validator>
                                <dxi-validation-rule type="numeric" [message]="'_validators.numeric' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="1" [max]="1440" [message]="'_validators.rangeLaDelayBeforeStopping' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>environments.lblCountAttemptsBeforeNotification</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedEnvironment.countAttemptsBeforeNotification">
                            <dx-validator>
                                <dxi-validation-rule type="numeric" [message]="'_validators.numeric' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="1" [max]="1440" [message]="'_validators.rangeCountAttemptsBeforeNotification' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createEnvironment()"
                               [visible]="isNew"></dx-button>
                    <dx-button class="save" [text]="'_commons.copy' | translate" (onClick)="copyEnvironment()"
                               [visible]="isCopy"></dx-button>
                    <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="this.isEditPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
